import { css } from '@emotion/react';
import { faCrosshairs } from '@fortawesome/pro-solid-svg-icons';
import { useDispatch } from 'react-redux';
import {
  ButtonComponent, ButtonSize, ButtonStyle,
} from '~/_shared/baseComponents/buttons';
import { Stack } from '~/_shared/baseComponents/layout/stack.component';
import { OverlayLoaderComponent } from '~/_shared/components/overlay/overlayLoader.component';
import { useTranslation } from '~/_shared/utils/hooks';
import { startSelectLocationTool } from '~/store/frontendState/mapTools/selectLocation/selectLocation.actionCreators';
import { SelectLocationConfiguration } from '~/store/frontendState/mapTools/selectLocation/selectLocation.state';

const zoomToLocationTextStyle = css({
  margin: 0,
});

const zoomToLocationWrapperStyle = css({
  padding: 10,
});

type ZoomToLocationProps = {
  readonly targetZoomLevel?: number;
  readonly isLoading: boolean;
};

export const ZoomToLocationComponent = ({ targetZoomLevel, isLoading }: ZoomToLocationProps) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const handleZoomTo = (targetZoomLevel?: number) => {
    dispatch(startSelectLocationTool(
      SelectLocationConfiguration.ZoomToLocation,
      { value: targetZoomLevel }
    ));
  };
  return (
    <Stack
      gap={8}
      css={zoomToLocationWrapperStyle}
    >
      <p css={zoomToLocationTextStyle}>{t('activeBoundary.zoomRequired')}</p>
      <ButtonComponent
        size={ButtonSize.Small}
        buttonStyle={ButtonStyle.Success}
        text={t('Zoom to Location')}
        prefixIcon={faCrosshairs}
        onClick={() => handleZoomTo(targetZoomLevel)}
      />
      {isLoading && <OverlayLoaderComponent />}
    </Stack>
  );
};
